import { SINGLE } from "../../constants/numbers.consts.js";
export const isLastArrayIndexUtil = (index, arr) => arr.length - SINGLE === index;
export default isLastArrayIndexUtil;
